module.exports = __webpack_public_path__ + "img/tangshi.1f379a95.jpg";